import gql from 'graphql-tag';

export default gql`
    mutation DietSetReplaceMealMutation(
        $request: UserDietSetReplaceMealInputType
    ) {
        me {
            dietSetReplaceMeal(request: $request) {
                __typename
                ... on UnauthorizedException {
                    code
                }
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
                ... on BasicMutationSuccess {
                    code
                }
            }
        }
    }
`;
